import React from 'react';
import PropTypes from 'prop-types';

import { Screen } from '@confluence/screen';
import { MainLayout } from '@confluence/main-layout';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { ContentHistoryLoader } from '@confluence/content-history';

export const ContentHistoryRoute = ({ params: { spaceKey, contentId, contentSlug } }) => {
	return (
		<Screen
			screenEvent={{ name: 'pageHistoryScreen', id: contentId }}
			pageState={{
				spaceKey,
				contentId,
				contentSlug,
			}}
		>
			<MainLayout spaceKey={spaceKey} navView={CONTAINER_HOME_ID}>
				<ContentHistoryLoader spaceKey={spaceKey} contentId={contentId} stack="classic" />
			</MainLayout>
		</Screen>
	);
};

ContentHistoryRoute.propTypes = {
	params: PropTypes.shape({
		contentId: PropTypes.string,
		contentSlug: PropTypes.string,
		spaceKey: PropTypes.string,
	}),
};
